import { Component, OnDestroy, inject } from "@angular/core";
import { ActivatedRoute, Params } from "@angular/router";
import { Subscription } from "rxjs";
import { tap } from "rxjs/operators";

@Component({
    templateUrl: "./infoportal-receipt-documents-page.component.html",
    styleUrls: ["./infoportal-receipt-documents-page.component.scss"],
    standalone: false
})
export class InfoportalApiReceiptDocumentsPageComponent implements OnDestroy {
  private _subs = new Subscription();
  public collectionNo = "";
  public receiptNo = "";

  constructor() {
    const route = inject(ActivatedRoute);

    this._subs.add(
      route.queryParams
        .pipe(tap(this._handleQueryParamsChange.bind(this)))
        .subscribe()
    );
  }

  ngOnDestroy(): void {
      this._subs.unsubscribe();
  }

  private _handleQueryParamsChange(params: Params) {
    if (
      !params.collectionNo ||
      (this.collectionNo === params.collectionNo &&
        this.receiptNo === params.receiptNo)
    ) {
      return;
    }
    this.collectionNo = params.collectionNo;
    this.receiptNo = params.receiptNo;
  }
}
